import SnotifyPlugin, { SnotifyPosition } from "vue-snotify";
import "vue-snotify/styles/material.css";

const defaultOptions = {
  timeout: 5000,
  showProgressBar: true,
  pauseOnHover: true,
  titleMaxLength: 20,
  bodyMaxLength: 80,
  position: SnotifyPosition.rightTop
};

export default {
  install(Vue, options) {
    Vue.use(SnotifyPlugin, options);
    // eslint-disable-next-line
    Vue.prototype.$notify = function(type, title, content, options = {}) {
      return this.$snotify[type](content, title, {
        closeOnClick: !options.copy,
        buttons: options.copy
          ? [
            {
              text: "Copy",
              action: () =>
                navigator.clipboard.writeText(content,
                  options.containerId &&
                  document.getElementById(options.containerId))
            },
            { text: "Close", action: toast => this.$snotify.remove(toast.id) }
          ]
          : [],
        ...defaultOptions,
        ...options
      });
    };
  }
};
